import api from './api';
import config from '../config';

export interface ContactUsMessage {
  id: number;
  phone_number: string;
  description: string;
  ip: string;
  user_agent: string;
  created_at: string;
}

export interface ContactUsListResponse {
  data: ContactUsMessage[];
  meta: {
    page: number;
    page_size: number;
    total_items: number;
    total_pages: number;
  };
}

export const contactUsService = {
  getAll: async (page: number = 1, limit: number = 10, search: string = '') => {
    const response = await api.get<ContactUsListResponse>(`/admin/contact-us`, {
      params: { page, limit, search },
    });
    return response.data;
  },

  delete: async (id: number) => {
    const response = await api.delete(`/admin/contact-us/${id}`);
    return response.data;
  },

  create: async (data: { phone_number: string; description: string }) => {
    const response = await api.post(`/contact-us`, data);
    return response.data;
  }
};
